import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class RMconfigurationService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  rmpmAccess:any;
  rmpmWrite:any;
  
  updateAccess(value: any,value2: any): void {
    this.rmpmAccess = value;
    this.rmpmWrite = value2;
  }

  constructor(private http: HttpClient) { }


  //NOT IN USE
  // getTreeStructure(): Observable<any[]> {
  //   return this.http.get<any[]>(this.baseUrl + 'get-configuration-tree');
  // }

  //NOT IN USE
  // addLine(data: any): Observable<any[]> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.post<any>(this.baseUrl + 'add-line', data, { headers: header });
  // }

  //NOT IN USE
  // updateLine(data: any): Observable<any[]> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.put<any>(this.baseUrl + 'update-line', data, { headers: header });
  // }

  //NOT IN USE
  // deleteLine(data: any): Observable<any> {
  //   return this.http.put<any>(this.baseUrl + 'delete-line', data);
  // }

  getWOType(headerData:any): Observable<any[]> {
    // return this.http.get<any[]>(this.baseUrl + 'get-WOType' , {params:headerData});
    return this.http.get<any[]>(this.O3CoreApiUrl + 'PMWOType/getWOType' , {params:headerData});
  }

  addWOType(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'add-WOType', data, { headers: header });
    return this.http.post<any>(this.O3CoreApiUrl + 'PMWOType/addWOType', data, { headers: header });
  }

  updateWOType(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any>(this.baseUrl + 'update-WOType', data, { headers: header });
    return this.http.put<any>(this.O3CoreApiUrl + 'PMWOType/updateWOType', data, { headers: header });
  }

  deleteWOType(data: any): Observable<any> {
    // return this.http.put<any>(this.baseUrl + 'delete-WOType', data);
    return this.http.put<any>(this.O3CoreApiUrl + 'PMWOType/DeleteWOType', data);
  }

  getTechnician(data: any): Observable<any[]> {
    // return this.http.get<any[]>(this.baseUrl + 'get-technician', { params: data });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'PMTechnician/getTechnician', { params: data });
  }

  addTechnician(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-technician', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'PMTechnician/addTechnician', data);
  }

  //NOT IN USE
  // deleteTechnician(data: any): Observable<any> {
  //   return this.http.put<any>(this.baseUrl + 'delete-technician', data);
  // }

  getPriority(headerData:any): Observable<any[]> {
    // return this.http.get<any[]>(this.baseUrl + 'get-priority' , {params:headerData});
    return this.http.get<any[]>(this.O3CoreApiUrl + 'PMPriority/getPriority' , {params:headerData});
  }

  addPriority(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'add-priority', data, { headers: header });
    return this.http.post<any>(this.O3CoreApiUrl + 'PMPriority/AddPriority', data, { headers: header });
  }

  updatePriority(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any>(this.baseUrl + 'update-priority', data, { headers: header });
    return this.http.put<any>(this.O3CoreApiUrl + 'PMPriority/UpdatePriority', data, { headers: header });
  }

  deletePriority(data: any): Observable<any> {
    // return this.http.put<any>(this.baseUrl + 'delete-priority', data);
    return this.http.put<any>(this.O3CoreApiUrl + 'PMPriority/DeletePriority', data);
  }

  getFailureMode(headerData:any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-failureMode' ,{params:headerData});
    return this.http.get<any>(this.O3CoreApiUrl + 'PMFailureMode/GetFailureMode' ,{params:headerData});
  }

  addFailureMode(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'add-failureMode', data, { headers: header });
    return this.http.post<any>(this.O3CoreApiUrl + 'PMFailureMode/AddFailureMode', data, { headers: header });
  }

  updateFailureMode(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any>(this.baseUrl + 'update-failureMode', data, { headers: header });
    return this.http.put<any>(this.O3CoreApiUrl + 'PMFailureMode/UpdateFailureMode', data, { headers: header });
  }

  deleteFailureMode(data: any): Observable<any> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.delete<any>(this.baseUrl + `delete-failureMode/${data.ID}`, { headers: header });
    return this.http.delete<any>(this.O3CoreApiUrl + `PMFailureMode/DeleteFailureMode/${data.ID}`, { headers: header });
  }

  getTime(headerData:any): Observable<any[]> {
    // return this.http.get<any>(this.baseUrl + 'get-time' , {params:headerData});
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTime/getTime' , {params:headerData});
  }

  addTime(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any>(this.baseUrl + 'add-time', data, { headers: header });
    return this.http.post<any>(this.O3CoreApiUrl + 'PMTime/addTime', data, { headers: header });
  }

  updateTime(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any>(this.baseUrl + 'update-time', data, { headers: header });
    return this.http.put<any>(this.O3CoreApiUrl + 'PMTime/updateTime', data, { headers: header });
  }

  //NOT IN USE
  // deleteTime(data: any): Observable<any> {
  //   const token = localStorage.getItem('token');
  //   const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   return this.http.delete<any>(this.baseUrl + `delete-time/${data.ID}`, { headers: header });
  // }

  // WOTypeMasterUpload(data: any): Observable<any[]> {
  //   return this.http.post<any>(this.baseUrl + 'add-master-wotype', data);
  // }

  // FailureModeMasterUpload(data: any): Observable<any[]> {
  //   return this.http.post<any>(this.baseUrl + 'add-master-failuremode', data);
  // }

  // PriorityMasterUpload(data: any): Observable<any[]> {
  //   return this.http.post<any>(this.baseUrl + 'add-master-priority', data);
  // }

  // DelayTimeMasterUpload(data: any): Observable<any[]> {
  //   return this.http.post<any>(this.baseUrl + 'add-master-delaytime', data);
  // }

  RMMasterUpload(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'add-master-rm', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'PMConfiguration/addMasterRM', data);
  }


  getMainKPIDashboardRM(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'RMDashboard/GetMainKPIDash', {
      ...data,
    });
  }


  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'RMDashboard/GetUnitList', data);
  }

  getLineData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'RMDashboard/GetLineList', data);
  }

  onSubmitBreakdown(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PMBreakdown/AddBreakdown', data);
  }

  onUpdateBreakdown(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PMBreakdown/UpdateBreakdown', data);
  }

  getBreakdown(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PMBreakdown/GetBreakdown', data);
  }
  
}
